import React from 'react';
import { Grid } from '@hbf/dsl';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

import {
  SearchResultsContentCard,
  useSearchResultsContentCard,
} from './SearchResultsContentCard';
import { SearchResultsList } from './SearchResultsList';
import { SearchListing } from '../types';

type Props = {
  items: SearchListing[];
};

const SearchResultsListNext: React.FC<Props> = ({ items }) => {
  const { contentCard } = useSearchResultsContentCard(items.length);
  const { md } = useMediaQuery();

  const cardBreakpoint = md ? 12 : 8;
  const topChunk = React.useMemo(
    () => items.slice(0, cardBreakpoint),
    [items, cardBreakpoint],
  );
  const bottomChunk = React.useMemo(
    () => items.slice(cardBreakpoint),
    [items, cardBreakpoint],
  );

  return (
    <React.Fragment>
      <SearchResultsList items={topChunk} dataTestLocator=": Top chunk" />
      {contentCard && (
        <Grid
          item
          xs={12}
          key={contentCard.title}
          data-test-locator="Search Results content card"
        >
          <SearchResultsContentCard card={contentCard} />
        </Grid>
      )}

      {bottomChunk.length > 0 && (
        <SearchResultsList
          items={bottomChunk}
          dataTestLocator=": Bottom chunk"
        />
      )}
    </React.Fragment>
  );
};

export { SearchResultsListNext };
